import { default as Modal, ModalProps as Props } from "antd/lib/modal";
import React, { ReactNode } from "react";
import { createGlobalStyle } from "styled-components";

export const Component: Component<{
  readonly children?: Component.Children;
  readonly Title?: string | Component;
  readonly Footer?: ReactNode;
  readonly onCancel: Props["onCancel"];
  readonly onOk?: Props["onOk"];
  readonly size?: "small" | "medium" | "large" | "jumbo" | string | number;
  readonly style?: Props["style"];
  readonly visible: Props["visible"];
}> = ({ Title, Footer, children, size, ...props }) => (
  <Modal
    title={Title}
    footer={Footer}
    {...props}
    width={
      size === "medium"
        ? "33vw"
        : size === "large"
        ? "66vw"
        : size === "jumbo"
        ? "85vw"
        : size === "small"
        ? "25vw"
        : size
    }
    style={{ width: "unset" }}
  >
    {children}
  </Modal>
);

export namespace AntOverride {
  export const Component = createGlobalStyle`
    @media print {
        .ant-modal {
            min-width: 20vw;
            width: fit-content;
            transform-origin: unset;
            top: 0;
            margin: 0;
        }
        .ant-modal-footer {
            display: none;
        }
        .ant-modal-content {
            box-shadow: unset;
       }
    }
    .ant-modal, .ant-modal-content {
      width: fit-content;
    }
    .ant-modal-header {
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
    }
    .ant-modal-content {
      border: 1px solid transparent;
      border-radius: 4px;
    }
    .ant-modal-confirm-body .ant-modal-confirm-title {
      display: inline-block;
    }
    .drawer-cancel-modal-wrapper.ant-modal {
      position: fixed;
      top: 40px;
      left: 22px;
      margin: auto;
    }
  `;
}
